export default "__VITE_ASSET__BmXcsUM1__"